import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map, List } from 'immutable'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { formatPrice } from '../../../services/plans/index'
import { createAbsolute } from '../../../services/url/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { parse as parseQuery } from '../../../services/query-string/index'
import { getAuthIsLoggedIn } from '../../../services/auth/index'
import { historyRedirect } from '../../../services/navigation/index'
import GaiaLogo, { TYPE_TEAL } from '../../GaiaLogo/index'
import { URL_ACCOUNT } from '../../../services/url/constants'
import { USD } from '../../../services/currency/index'
import { format as formatDateTime, getDateTime } from '../../../services/date-time/index'
import { getPrimary } from '../../../services/languages/index'
import Link, { TARGET_BLANK } from '../../Link/index'

function MyAccountInvoicePage (props) {
  const {
    staticText,
    location,
    history,
    auth,
    user,
    userAccount,
    page,
  } = props
  const userLanguage = getPrimary(user.getIn(['data', 'language']))
  const { invoiceId } = parseQuery(location.search)
  const invoiceProcessing = userAccount.get('billingInvoiceProcessing')
  const invoice = userAccount.getIn(['details', 'data', 'billing', 'invoice'], Map())
  const gift = invoice.getIn(['data', 'gift'], undefined)
  const invoiceError = (invoice.size > 1 && !invoice.get('success')) || (invoice.get('error'))
  const dataReady = !invoiceProcessing && invoice.size >= 1
  const currencyIso = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'currencyIso']) || USD
  const dateFormatString = 'MM/DD/YYYY'
  const locale = page.get('locale')
  const invoiceDate = getDateTime(invoice.getIn(['data', 'invoiceDate']))
  const invoiceDateFormatted = formatDateTime(invoiceDate, locale, dateFormatString)
  const invoiceDueDate = getDateTime(invoice.getIn(['data', 'invoiceDueDate']))
  const invoiceDueDateFormatted = formatDateTime(invoiceDueDate, locale, dateFormatString)

  useEffect(() => {
    if (!getAuthIsLoggedIn(auth) || !invoiceId) {
      const language = user.getIn(['data', 'language'])
      historyRedirect({
        history, url: URL_ACCOUNT, auth, language,
      })
    }
  }, [])

  const placeholderRows = () => {
    return (
      <React.Fragment>
        <div className="my-account-invoice-page__placeholder-row" />
        <div className="my-account-invoice-page__placeholder-row" />
        <div className="my-account-invoice-page__placeholder-row" />
        <div className="my-account-invoice-page__placeholder-row" />
      </React.Fragment>
    )
  }

  const getGaiaAddress = () => {
    return (
      <div className="my-account-invoice-page__address">
        <div className="my-account-invoice-page__address-item my-account-invoice-page__address-item--strong">
          Gaia, Inc.
        </div>
        <div className="my-account-invoice-page__address-item">
          833 W. South Boulder Road Bldg. G
        </div>
        <div className="my-account-invoice-page__address-item">
          Louisville, CO 80027
        </div>
      </div>
    )
  }

  const renderDesktopTable = () => {
    if (!dataReady) {
      return null
    }

    return (
      <table className="my-account-invoice-page__table">
        <thead className="my-account-invoice-page__table-header">
          <tr>
            <th className="my-account-invoice-page__table-header-cell">
              {staticText.getIn(['data', 'description'])}
            </th>
            <th className="my-account-invoice-page__table-header-cell my-account-invoice-page__table-header-cell--right-align">
              {staticText.getIn(['data', 'subtotal'])}
            </th>
            <th className="my-account-invoice-page__table-header-cell my-account-invoice-page__table-header-cell--right-align">
              {staticText.getIn(['data', 'tax'])}
            </th>
            <th className="my-account-invoice-page__table-header-cell my-account-invoice-page__table-header-cell--right-align">
              {staticText.getIn(['data', 'totalAmount'])}
            </th>
          </tr>
        </thead>
        <tbody className="my-account-invoice-page__table-body">
          {
            invoice.getIn(['data', 'items'], List()).map((item, index) => {
              const rowNumber = index

              return (
                <tr className="my-account-invoice-page__table-row" key={`row-${rowNumber}`}>
                  <td className="my-account-invoice-page__table-cell">
                    {item.get('chargeName')}
                  </td>
                  <td className="my-account-invoice-page__table-cell my-account-invoice-page__table-cell--right-align">
                    {formatPrice(currencyIso, item.get('amount', 0), false, null, userLanguage)}
                  </td>
                  <td className="my-account-invoice-page__table-cell my-account-invoice-page__table-cell--right-align">
                    {formatPrice(currencyIso, item.get('taxAmount', 0), false, null, userLanguage)}
                  </td>
                  <td className="my-account-invoice-page__table-cell my-account-invoice-page__table-cell--right-align">
                    {formatPrice(currencyIso, item.get('totalAmount', 0), false, null, userLanguage)}
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    )
  }

  const renderMobileTable = () => {
    if (!dataReady) {
      return null
    }

    return (
      <div className="my-account-invoice-page__mobile-table">
        {
          invoice.getIn(['data', 'items'], List()).map((item, index) => {
            const rowNumber = index

            return (
              <div className="my-account-invoice-page__mobile-row" key={`row-${rowNumber}`}>
                <div className="my-account-invoice-page__mobile-label">
                  {staticText.getIn(['data', 'description'])}
                </div>
                <div className="my-account-invoice-page__mobile-value">
                  {item.get('chargeName')}
                </div>
                <div className="my-account-invoice-page__mobile-label">
                  {staticText.getIn(['data', 'subtotal'])}
                </div>
                <div className="my-account-invoice-page__mobile-value">
                  {formatPrice(currencyIso, item.get('amount', 0), false, null, userLanguage)}
                </div>
                <div className="my-account-invoice-page__mobile-label">
                  {staticText.getIn(['data', 'tax'])}
                </div>
                <div className="my-account-invoice-page__mobile-value">
                  {formatPrice(currencyIso, item.get('taxAmount', 0), false, null, userLanguage)}
                </div>
                <div className="my-account-invoice-page__mobile-label">
                  {staticText.getIn(['data', 'totalAmount'])}
                </div>
                <div className="my-account-invoice-page__mobile-value">
                  {formatPrice(currencyIso, item.get('totalAmount', 0), false, null, userLanguage)}
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }

  const renderGiftInfo = () => {
    const url = createAbsolute(`/gift/redeem?token=${gift.get('token')}`)
    const email = gift.get('recipientEmail')
    const expiresAt = formatDateTime(new Date(gift.get('expiresAt')), locale, 'MM/DD/YYYY')
    const mailto = `mailto:${email}}`
    return (
      <>
      <div className="my-account-invoice-page__gift-item--strong">
        {staticText.getIn(['data', 'giftMembership'])}
      </div>
      <div className="my-account-invoice-page__gift-item">
        {staticText.getIn(['data', 'recipientName'])}{`${gift.get('recipientFirstName')} ${gift.get('recipientLastName')}`}
      </div>
      {email
        ? <div className="my-account-invoice-page__gift-item">
          {staticText.getIn(['data', 'recipientEmail'])}
          <a
          target={TARGET_BLANK}
          href={mailto}
        >
          {email}
        </a>
        </div>
        : null}
      <div className="my-account-invoice-page__gift-item">
        {staticText.getIn(['data', 'expirationDate'])}{expiresAt}
      </div>
      <div className="my-account-invoice-page__gift-item">
        {staticText.getIn(['data', 'giftRedeemUrl'])}
        <Link
          className="my-account-invoice-page__gift-url"
          target={TARGET_BLANK}
          directLink
          to={url}
        >
          {url}
        </Link>
      </div>
      </>
    )
  }

  const getInvoiceDetails = () => {
    if (!dataReady) {
      return null
    }

    return (
      <div className="my-account-invoice-page__details">
        <div className="my-account-invoice-page__detail-item">
          <span className="my-account-invoice-page__detail-label">
            {`${staticText.getIn(['data', 'email'])}: `}
          </span>
          <span className="my-account-invoice-page__detail-value">
            {invoice.getIn(['data', 'userEmail'])}
          </span>
        </div>
        <div className="my-account-invoice-page__detail-item">
          <span className="my-account-invoice-page__detail-label">
            {`${staticText.getIn(['data', 'accountNumber'])}: `}
          </span>
          <span className="my-account-invoice-page__detail-value">
            {invoice.getIn(['data', 'accountNumber'])}
          </span>
        </div>
        <div className="my-account-invoice-page__detail-item">
          <span className="my-account-invoice-page__detail-label">
            {`${staticText.getIn(['data', 'invoiceNumber'])}: `}
          </span>
          <span className="my-account-invoice-page__detail-value">
            {invoice.getIn(['data', 'invoiceNumber'])}
          </span>
        </div>
        <div className="my-account-invoice-page__detail-item">
          <span className="my-account-invoice-page__detail-label">
            {`${staticText.getIn(['data', 'invoiceDate'])}: `}
          </span>
          <span className="my-account-invoice-page__detail-value">
            {invoiceDateFormatted}
          </span>
        </div>
        <div className="my-account-invoice-page__detail-item">
          <span className="my-account-invoice-page__detail-label">
            {`${staticText.getIn(['data', 'dueDate'])}: `}
          </span>
          <span className="my-account-invoice-page__detail-value">
            {invoiceDueDateFormatted}
          </span>
        </div>
      </div>
    )
  }

  const getTotalDetails = () => {
    if (!dataReady) {
      return null
    }

    return (
      <div className="my-account-invoice-page__total-details">
        <table className="my-account-invoice-page__total-details-table">
          <tbody className="my-account-invoice-page__total-details-body">
            <tr className="my-account-invoice-page__total-details-row">
              <td className="my-account-invoice-page__total-details-cell my-account-invoice-page__total-details-cell--label">
                {`${staticText.getIn(['data', 'amount'])}: `}
              </td>
              <td className="my-account-invoice-page__total-details-cell">
                {formatPrice(currencyIso, invoice.getIn(['data', 'subtotal']), true, null, userLanguage)}
              </td>
            </tr>
            <tr className="my-account-invoice-page__total-details-row">
              <td className="my-account-invoice-page__total-details-cell my-account-invoice-page__total-details-cell--label">
                {`${staticText.getIn(['data', 'totalTax'])}: `}
              </td>
              <td className="my-account-invoice-page__total-details-cell">
                {formatPrice(currencyIso, invoice.getIn(['data', 'tax']), true, null, userLanguage)}
              </td>
            </tr>
            <tr className="my-account-invoice-page__total-details-row">
              <td className="my-account-invoice-page__total-details-cell my-account-invoice-page__total-details-cell--label">
                {`${staticText.getIn(['data', 'total'])}: `}
              </td>
              <td className="my-account-invoice-page__total-details-cell">
                {formatPrice(currencyIso, invoice.getIn(['data', 'totalAmount']), true, null, userLanguage)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  if (!getAuthIsLoggedIn(auth) || !invoiceId) {
    return null
  }

  return (
    <div className="my-account-invoice-page">
      <header className="my-account-invoice-page__header">
        <div className="my-account-invoice-page__header-left">
          <GaiaLogo className={['my-account-invoice-page__logo']} type={TYPE_TEAL} />
          {getGaiaAddress()}
        </div>
        {
          !invoiceError && dataReady
            ? <div className="my-account-invoice-page__header-right">
              {getInvoiceDetails()}
            </div>
            : null
        }
      </header>
      {
        !dataReady && !invoiceError
          ? <React.Fragment>
            {placeholderRows()}
          </React.Fragment>
          : null
      }
      {
        !invoiceError && dataReady
          ? <React.Fragment>
            <div className="my-account-invoice-page__table-container">
              {renderDesktopTable()}
            </div>
            <div className="my-account-invoice-page__mobile-table-container">
              {renderMobileTable()}
            </div>
            {gift
              ? <div className="my-account-invoice-page__gift-container">
                {renderGiftInfo()}
              </div>
              : null}
            <footer className="my-account-invoice-page__footer">
              {getTotalDetails()}
            </footer>
          </React.Fragment>
          : null
      }
      {
        invoiceError
          ? <div className="my-account-invoice-page__error">
            {staticText.getIn(['data', 'errorMessage'])}
          </div>
          : null
      }
    </div>
  )
}

MyAccountInvoicePage.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  userAccount: ImmutablePropTypes.map.isRequired,
  page: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connectRedux(
    (state) => ({
      auth: state.auth,
      user: state.user,
      userAccount: state.userAccount,
      page: state.page,
    }),
  ),
  connectStaticText({ storeKey: 'myAccountInvoicePage' }),
)(MyAccountInvoicePage)
